import PageTitle from "components/PageTitle";
import React from "react";
import { Card } from "react-bootstrap";
import VisaoAnualGrid from "./VisaoAnualGrid";



export default function Reavaliacao(){

    return (
        <>
            <PageTitle
                breadCrumbItems={[
                    { label: "Relatório Parcial", path: "#" },
                    { label: "Avaliação e Reavaliação", path: "/relatorio-parcial/reavaliacao", active: true },
                ]}
                title="Avaliação e Reavaliação"
            />
                    <VisaoAnualGrid/>
        </>
    )
}